/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran this thru claudes code refactoring tool

// redesign this component to look more elegant and polished and accents
// and add a little more pizzaz to the menu items and add hover effects 
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
// give me the entire code to copy

// i am having an issue with Sidebar menu on mobile
// some of the other elemants are under it and some of them are on top
// i need the sidebar menu to be on top of everything when it is open and on mobile
// give me the entire code to copy and any instructions to implement

// i am having an issue with Sidebar menu on mobile
// some of the other elemants are under it and some of them are on top



// create slide in and slide out animations for the hide/show sidebar menu on desktop
// give me the relevant code to copy



import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

import { FaList, FaRegUser, FaRegHeart, FaRegThumbsUp } from 'react-icons/fa';
import { GrGallery } from "react-icons/gr";
import { IoIosArrowForward, IoMdLogOut } from 'react-icons/io';
import { MdPayment, MdOutlineTableBar, MdOutlineRestaurantMenu, MdArrowForwardIos,
    MdOutlineKeyboardDoubleArrowRight, MdOutlineKeyboardDoubleArrowLeft } from 'react-icons/md';

import {  } from "react-icons/md";

import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';
import { AiOutlineDashboard, AiOutlineShoppingCart } from 'react-icons/ai';
import { GoGift } from 'react-icons/go';
import { TbListDetails } from 'react-icons/tb';

import api from '../api/api';

import { get_event_details } from '../store/reducers/eventDetailsReducer';
import { user_reset } from '../store/reducers/authReducer';
import { reset_count } from '../store/reducers/cartReducer';

import Header from '../components/Header';
import Footer from '../components/Footer';
import GetSellerConfig from '../components/GetSellerConfig';

import toast from 'react-hot-toast';
import config from '../config';

// ─── Nav Item ────────────────────────────────────────────────────────────────

const NavItem = ({
    path, label, icon, currentPath, onClick,
    primaryColor, colorSuffixLight, colorSuffixMedium, colorSuffixDark
    }) => {
    const isActive = currentPath === path;
    const [hovered, setHovered] = useState(false);
    const showAccent = isActive || hovered;

    return (
        <li className="list-none">
            <div
                onClick={() => onClick(path)}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                className="relative flex items-center cursor-pointer rounded-lg overflow-hidden transition-all 
                duration-300 ease-in-out mx-1 my-0.5 border-none"
                style={{
                    backgroundColor: showAccent ? primaryColor + colorSuffixLight : 'transparent',
                    borderColor: showAccent ? primaryColor + colorSuffixDark : 'transparent',
                    paddingTop: '5px',
                    paddingBottom: '5px',
                    paddingLeft: '14px',
                    paddingRight: '12px',
                    //borderLeft: `4px solid ${isActive ? primaryColor + colorSuffixDark : 'transparent'}`,
                }}>
                {/* Left accent bar */}
                <span
                    className="absolute left-0.5 top-1 bottom-1 rounded-full transition-all duration-300 ease-in-out"
                    style={{
                        width: showAccent ? '4px' : '0px', // showAccent ? '3px' : '0px',
                        backgroundColor: primaryColor + colorSuffixDark,
                        opacity: showAccent ? 1 : 0,
                    }} />

                {/* Icon */}
                <span 
                    className="flex border-none border-black items-center justify-center transition-all duration-300 ease-in-out"
                    style={{
                        fontSize: '20px',
                        marginRight: '7px',
                        color: isActive ? primaryColor + colorSuffixDark : primaryColor + colorSuffixDark, // colorSuffixMedium,
                        transform: hovered && !isActive ? 'scale(1.15)' : 'scale(1)',
                    }}>
                    {icon}
                </span>

                {/* Label */}
                <span
                    className="text-[12.5px] tracking-wide transition-all duration-200 border-none border-black"
                    style={{
                        fontWeight: isActive ? 600 : 400,
                        letterSpacing: isActive ? '0.02em' : '0.01em',
                        color: isActive ? primaryColor + colorSuffixDark : primaryColor + colorSuffixDark, //  colorSuffixMedium,
                    }}>
                    {label}
                </span>

                {/* Active dot */}
                {isActive && (
                    <div className="flex items-center ml-auto"
                        >
                        <div
                            className="hidden mr-1 w-2 h-2 rounded-full"
                            style={{ backgroundColor: primaryColor + colorSuffixDark }}>
                        </div>
                        <div
                            className="hidden mr-0 w-2 h-2 rounded-full"
                            style={{ backgroundColor: primaryColor + colorSuffixDark }}>
                        </div>
                        <MdArrowForwardIos size={18} style={{ color: primaryColor + colorSuffixDark }} />
                    </div>
                )}
            </div>
        </li>
    );
};

// ─── Logout Item ─────────────────────────────────────────────────────────────

const LogoutItem = ({ onClick, primaryColor, colorSuffixLight, colorSuffixMedium, colorSuffixDark }) => {
    const [hovered, setHovered] = useState(false);

    return (
        <li className="list-none">
            <div
                onClick={onClick}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                className="relative flex items-center cursor-pointer rounded-lg overflow-hidden 
                    transition-all duration-300 ease-in-out mx-1 my-0.5"
                style={{
                    backgroundColor: hovered ? primaryColor + colorSuffixLight : 'transparent',
                    paddingTop: '9px',
                    paddingBottom: '9px',
                    paddingLeft: '14px',
                    paddingRight: '12px',
                }}>
                {/* Left accent bar */}
                <span
                    className="absolute left-0 top-1 bottom-1 rounded-full transition-all duration-300 ease-in-out"
                    style={{
                        width: hovered ? '3px' : '0px',
                        backgroundColor: primaryColor + colorSuffixDark,
                        opacity: hovered ? 1 : 0,
                    }}
                />

                <span
                    className="flex items-center justify-center transition-transform duration-300"
                    style={{
                        fontSize: '20px',
                        marginRight: '10px',
                        color: primaryColor + colorSuffixMedium,
                        transform: hovered ? 'scale(1.15)' : 'scale(1)',
                    }}>
                    <IoMdLogOut />
                </span>

                <span
                    className="text-[12.5px] tracking-wide"
                    style={{
                        fontWeight: 400,
                        color: primaryColor + colorSuffixMedium,
                    }}>
                    Logout
                </span>
            </div>
        </li>
    );
};

// ─── CustomerDashboard ───────────────────────────────────────────────────────

const CustomerDashboard = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;

    const { userInfo } = useSelector(state => state.auth);
    const { eventDetails } = useSelector(state => state.eventDetails);

    const {
        sellerColorDark, sellerColorMedium, sellerColorLight,
        sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowSiteSamplesMenus,
        sellerBoolShowSitePackages, sellerBoolShowCustomerTestimonials,
    } = GetSellerConfig();

    const [filterShow, setFilterShow] = useState(false);
    const [customMenuProductsLength, setCustomMenuProductsLength] = useState(0);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    useEffect(() => {
        dispatch(get_event_details(userInfo.id));
    }, [sellerFrontendURL, userInfo.id]);

    useEffect(() => {
        if (eventDetails?.customMenuProducts) {
            try {
                setCustomMenuProductsLength(JSON.parse(eventDetails.customMenuProducts).length);
            } catch {
                setCustomMenuProductsLength(0);
            }
        }
    }, [eventDetails?.customMenuProducts]);

    const logout = async () => {
        try {
            await api.get('/customer/logout');
            localStorage.removeItem('customerToken');
            dispatch(user_reset());
            dispatch(reset_count());
            toast.success('Logout successful');
            navigate('/login');
        } catch (error) {
            console.error(error?.response?.data);
            toast.error('Logout failed. Please try again.');
        }
    };

    const goToPage = (path) => {
        navigate(path);
        setFilterShow(false);
    };

    // ── Nav config ────────────────────────────────────────────────────────────
    const navItems = [
        { path: '/customerDashboard',                               label: 'My Dashboard',          icon: <AiOutlineDashboard /> },
        { path: '/customerDashboard/myOrders',                      label: 'My Orders',             icon: <AiOutlineShoppingCart /> },
        { path: '/customerDashboard/myProfile',                     label: 'My Profile',            icon: <FaRegUser /> },
        { path: '/customerDashboard/depositsAndBalances',           label: 'Deposits & Balances',   icon: <MdPayment />, },
        { path: '/customerDashboard/eventDetailsCustomerDashboard', label: 'Event Details',         icon: <TbListDetails /> },
        { path: '/customerDashboard/FloorPlanner',                  label: 'Floor Planner',         icon: <MdOutlineTableBar /> },
        { path: '/customerDashboard/sampleMenus',                   label: 'Sample Menus',          icon: <MdOutlineRestaurantMenu />,   show: sellerBoolShowSiteSamplesMenus },
        { path: '/customerDashboard/myCustomMenu',                  label: 'My Custom Menu',        icon: <MdOutlineRestaurantMenu />,   show: customMenuProductsLength > 0 },
        { path: '/customerDashboard/sellerPackages',                label: 'Packages',              icon: <GoGift />,                    show: sellerBoolShowSitePackages },
        { path: '/customerDashboard/myWishlist',                    label: 'My Wishlist',           icon: <FaRegHeart />,                show: sellerBoolShowSiteWishList },
        { path: '/customerDashboard/myGallery',                     label: 'My Gallery',            icon: <GrGallery />, },              
        { path: '/customerDashboard/chat',                          label: 'Chat',                  icon: <IoChatbubbleEllipsesOutline />, show: sellerBoolShowSiteChat },
        { path: '/customerDashboard/customerTestimonialsDashboard', label: 'Testimonials',          icon: <FaRegThumbsUp />,             show: sellerBoolShowCustomerTestimonials },
    ];

    const visibleNavItems = navItems.filter(item => item.show === undefined || item.show);

    // ── Shared color props passed into nav items ───────────────────────────────
    const navColorProps = {
        primaryColor: sellerPrimaryColor1,
        colorSuffixLight: sellerColorSuffixLight,
        colorSuffixMedium: sellerColorSuffixMedium,
        colorSuffixDark: sellerColorSuffixDark,
        //componentBg: sellerComponentBackgroundColor,
        // primaryColor: sellerPrimaryColor1,
        // colorSuffixLight: sellerColorSuffixLight,
        // colorSuffixMedium: sellerColorSuffixMedium,
        // colorSuffixDark: sellerColorSuffixDark,
        // componentBg: sellerComponentBackgroundColor,
    };

    // ─────────────────────────────────────────────────────────────────────────

    return (
    <div>
        <Header />
        {/* min-h-screen */}
        <div className="pt-6 pb-10" 
            style={{ 
                backgroundColor: sellerComponentBackgroundColor
            }}>
            
            {/* Mobile menu toggle */}
            <div className="w-[90%] mx-auto md-lg:block hidden mb-3">
                <div className="bg-white w-fit rounded-xl border"
                    style={{ borderColor: sellerColorDark }}>
                    <button
                        onClick={() => setFilterShow(prev => !prev)}
                        aria-label="Toggle navigation menu"
                        className="flex items-center justify-center w-9 h-9 rounded-xl transition-all duration-200"
                        style={{
                            backgroundColor: sellerColorLight,
                            color: sellerColorDark,
                        }}>
                        <FaList size={20} />
                    </button>
                </div>
            </div>                

            <div className="h-full mx-auto bg-white border-none border-black">
                <div className="flex md-lg:w-[90%] mx-auto relative gap-4 px-4 md-lg:px-0"
                    style={{
                        backgroundColor: sellerComponentBackgroundColor,
                    }}>

                    {/* ── Mobile backdrop overlay ──────────────────────── */}
                    {filterShow && (
                        <div
                            className="fixed inset-0 bg-black/40 z-[140] md-lg:block hidden"
                            onClick={() => setFilterShow(false)}
                        />
                    )}

                    {/* ── Sidebar menu ────────────────────────────────────── */}
                    {/* 
                        On mobile (md-lg and below): fixed overlay, above everything (z-[150])
                        On desktop: normal flex item, static position 
                        md-lg:pt-40 controls distance from top when open, 
                        md-lg:transition-transform and md-lg:translate-x-0 or -translate-x-full controls slide in/out effect
                    */}
                    <div
                        className={`
                            md-lg:fixed md-lg:top-0 md-lg:left-0 md-lg:h-full md-lg:z-[150]
                            md-lg:transition-transform md-lg:duration-300 md-lg:ease-in-out
                            md-lg:pt-48 md-lg:pl-4 md-lg:pb-8 md-lg:overflow-y-auto
                            ${filterShow ? 'md-lg:translate-x-0' : 'md-lg:-translate-x-full'}
                            flex-shrink-0
                        `}>
                        <nav
                            className="rounded-2xl w-[190px] py-0 px-0 border-none border-black"
                            style={{
                                backgroundColor: sellerColorLight,
                                borderColor: sellerColorDark,
                            }}>
                            <div className="bg-white rounded-2xl">
                                <div className="rounded-2xl border-2"
                                    style={{ 
                                        backgroundColor: sellerColorLight,
                                        borderColor: sellerColorDark,
                                    }}>
                                    <div
                                        className="mx-1 mb-1 pb-1"
                                        style={{ border: `0px solid ${sellerColorDark}` }}>
                                        <p
                                            className="hidden text-[10px] uppercase tracking-widest font-semibold px-1"
                                            style={{ color: sellerColorMedium }}>
                                            My Account
                                        </p>
                                    </div>

                                    {/* Nav items */}
                                    <ul className="flex flex-col gap-0.5 px-0">
                                        {visibleNavItems.map(item => (
                                            <NavItem
                                                key={item.path}
                                                path={item.path}
                                                label={item.label}
                                                icon={item.icon}
                                                currentPath={pathname}
                                                onClick={goToPage}
                                                {...navColorProps}
                                            />
                                        ))}
                                        <div className="hidden">
                                            <LogoutItem onClick={logout} {...navColorProps} />
                                        </div>
                                        <li className="list-none my-2"/>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>

                    {/* ── Main content ───────────────────────────────── */}
                    <div className="flex-1 min-w-0 md-lg:w-full">
                        <div className="md-lg:mx-0">
                            <Outlet />
                        </div>
                    </div>
                </div>                    
            </div>
        </div>

        <Footer />
    </div>
);

};

export default CustomerDashboard;







//menu on moblie issue

// return (
//         <div>
//             <Header />
//             <div className="min-h-screen pt-6 pb-10" 
//                 style={{ 
//                     backgroundColor: sellerComponentBackgroundColor // top and bottom
//                 }}>
                
//                 {/* Mobile menu toggle 
//                 the dashboard menu that slides in not clearly visible
//                 */}
                
//                 <div className="w-[90%] mx-auto md-lg:block hidden mb-3">
//                     <div className="bg-white w-fit rounded-xl border"
//                         style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
//                         <button
//                             onClick={() => setFilterShow(prev => !prev)}
//                             aria-label="Toggle navigation menu"
//                             className="flex items-center justify-center w-9 h-9 rounded-xl transition-all duration-200"
//                             style={{
//                                 backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
//                                 color: sellerPrimaryColor1 + sellerColorSuffixDark,
//                             }}>
//                             <FaList size={14} />
//                         </button>
//                     </div>
//                 </div>                

//                 <div className="h-full mx-auto bg-white border-none border-black">
//                     <div className="flex md-lg:w-[90%] mx-auto relative gap-4 px-4 md-lg:px-0"
//                         style={{
//                             backgroundColor: sellerComponentBackgroundColor,
//                         }}>
//                         {/* ── Sidebar menu ────────────────────────────────────── */}
//                         <div className="bg-white rounded-2xl h-fit">
//                             <nav
//                                 className={`
//                                     flex-shrink-0 rounded-2xl z-150 md-lg:absolute
//                                     ${filterShow ? 'md-lg:left-0' : 'md-lg:-left-[360px]'}
//                                     w-[190px] py-0 px-0 border-none border-black
//                                     transition-all duration-300 ease-in-out
//                                 `}
//                                 style={{
//                                     backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
//                                     borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
//                                     //boxShadow: `0 2px 20px ${sellerPrimaryColor1}18`,
//                                 }}>
//                                 {/* Sidebar header accent */}
//                                 <div className="bg-white rounded-2xl">
//                                     <div className="rounded-2xl border-2 border-red-500"
//                                         style={{ 
//                                             backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
//                                             borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
//                                         }}>
//                                         <div
//                                             className="mx-3 mb-4 pb-4"
//                                             style={{ border: `0px solid ${sellerPrimaryColor1 + sellerColorSuffixDark}` }}>
//                                             <p
//                                                 className="hidden text-[10px] uppercase tracking-widest font-semibold px-1"
//                                                 style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
//                                                 My Account
//                                             </p>
//                                         </div>

//                                         {/* Nav items */}
//                                         <ul className="flex flex-col gap-0.5 px-0">
//                                             {visibleNavItems.map(item => (
//                                                 <NavItem
//                                                     key={item.path}
//                                                     path={item.path}
//                                                     label={item.label}
//                                                     icon={item.icon}
//                                                     currentPath={pathname}
//                                                     onClick={goToPage}
//                                                     {...navColorProps}
//                                                 />
//                                             ))}

//                                             {/* Divider before logout */}
//                                             <li className="hidden list-none my-2">
//                                                 <div
//                                                     className="w-full h-px"
//                                                     style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight }}
//                                                 />
//                                             </li>
//                                             <div className="hidden">
//                                                 <LogoutItem  className="hidden" onClick={logout} {...navColorProps} />
//                                             </div>
//                                             <li className="list-none my-2"/>
//                                         </ul>
//                                     </div>
//                                 </div>
//                             </nav>
//                         </div>

//                         {/* ── Main content ───────────────────────────────── */}
//                         <div className="flex-1 min-w-0 md-lg:w-full">
//                             <div className="md-lg:mx-0">
//                                 <Outlet />
//                             </div>
//                         </div>
//                     </div>                    
//                 </div>
//             </div>

//             <Footer />
//         </div>
//     );
// };

//refactored
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Outlet, useNavigate, useLocation } from 'react-router-dom';

// import { FaList, FaRegUser, FaRegHeart, FaRegThumbsUp } from 'react-icons/fa';
// import { IoMdLogOut } from 'react-icons/io';
// import { MdPayment, MdOutlineTableBar, MdOutlineRestaurantMenu } from 'react-icons/md';
// import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';
// import { AiOutlineDashboard, AiOutlineShoppingCart } from 'react-icons/ai';
// import { GoGift } from 'react-icons/go';
// import { TbListDetails } from 'react-icons/tb';

// import api from '../api/api';
// import { get_product_deposit_details } from '../store/reducers/homeReducer';
// import { get_event_details } from '../store/reducers/eventDetailsReducer';
// import { user_reset } from '../store/reducers/authReducer';
// import { reset_count } from '../store/reducers/cartReducer';

// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import GetSellerConfig from '../components/GetSellerConfig';

// import toast from 'react-hot-toast';
// import config from '../config';

// // ─── Nav Item ────────────────────────────────────────────────────────────────

// const NavItem = ({ path, label, icon, currentPath, onClick, borderColor }) => {
//     const isActive = currentPath === path;
//     return (
//         <li className="flex justify-start items-center py-1">
//             <div
//                 onClick={() => onClick(path)}
//                 className="w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md hover:pl-3 transition-all duration-300"
//                 style={{ borderColor }}
//             >
//                 <div className={`${isActive ? 'font-bold' : 'font-normal'} hover:font-bold flex justify-start items-center gap-1`}>
//                     <span className="text-xl">{icon}</span>
//                     {label}
//                 </div>
//             </div>
//         </li>
//     );
// };

// // ─── CustomerDashboard ───────────────────────────────────────────────────────

// const CustomerDashboard = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;

//     const { userInfo } = useSelector(state => state.auth);
//     const { depositProduct } = useSelector(state => state.home);
//     const { eventDetails } = useSelector(state => state.eventDetails);

//     const {
//         sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowSiteSamplesMenus,
//         sellerBoolShowSitePackages,
//         sellerBoolShowCustomerTestimonials,
//     } = GetSellerConfig();

//     const [filterShow, setFilterShow] = useState(false);
//     const [customMenuProductsLength, setCustomMenuProductsLength] = useState(0);

//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const { pathname } = useLocation();

//     useEffect(() => {
//         dispatch(get_product_deposit_details(sellerFrontendURL));
//         dispatch(get_event_details(userInfo.id));
//     }, [sellerFrontendURL, userInfo.id]);

//     useEffect(() => {
//         if (eventDetails?.customMenuProducts) {
//             try {
//                 setCustomMenuProductsLength(JSON.parse(eventDetails.customMenuProducts).length);
//             } catch {
//                 setCustomMenuProductsLength(0);
//             }
//         }
//     }, [eventDetails?.customMenuProducts]);

//     const logout = async () => {
//         try {
//             await api.get('/customer/logout');
//             localStorage.removeItem('customerToken');
//             dispatch(user_reset());
//             dispatch(reset_count());
//             toast.success('Logout successful');
//             navigate('/login');
//         } catch (error) {
//             console.error(error?.response?.data);
//             toast.error('Logout failed. Please try again.');
//         }
//     };

//     const goToPage = (path) => {
//         navigate(path);
//         setFilterShow(false);
//     };

//     // ── Nav config ────────────────────────────────────────────────────────────
//     const navItems = [
//         { path: '/customerDashboard',                              label: 'My Dashboard',  icon: <AiOutlineDashboard /> },
//         { path: '/customerDashboard/myOrders',                     label: 'My Orders',     icon: <AiOutlineShoppingCart /> },
//         { path: '/customerDashboard/myProfile',                    label: 'My Profile',    icon: <FaRegUser /> },
//         { path: '/customerDashboard/',                  label: 'Give Deposit',  icon: <MdPayment />,                show: !!depositProduct },
//         { path: '/customerDashboard/eventDetailsCustomerDashboard',label: 'Event Details', icon: <TbListDetails /> },
//         { path: '/customerDashboard/FloorPlanner',                 label: 'Floor Planner', icon: <MdOutlineTableBar /> },
//         { path: '/customerDashboard/sampleMenus',                  label: 'Sample Menus',  icon: <MdOutlineRestaurantMenu />,  show: sellerBoolShowSiteSamplesMenus },
//         { path: '/customerDashboard/myCustomMenu',                 label: 'My Custom Menu',icon: <MdOutlineRestaurantMenu />,  show: customMenuProductsLength > 0 },
//         { path: '/customerDashboard/sellerPackages',               label: 'Packages',      icon: <GoGift />,                   show: sellerBoolShowSitePackages },
//         { path: '/customerDashboard/myWishlist',                   label: 'My Wishlist',   icon: <FaRegHeart />,               show: sellerBoolShowSiteWishList },
//         { path: '/customerDashboard/chat',                         label: 'Chat',          icon: <IoChatbubbleEllipsesOutline />, show: sellerBoolShowSiteChat },
//         { path: '/customerDashboard/customerTestimonialsDashboard',label: 'Testimonials',  icon: <FaRegThumbsUp />,            show: sellerBoolShowCustomerTestimonials },
//     ];

//     const visibleNavItems = navItems.filter(item => item.show === undefined || item.show);

//     // ─────────────────────────────────────────────────────────────────────────

//     return (
//         <div>
//             <Header />
//             <div className="bg-slate-200 pt-4">
//                 {/* Mobile menu toggle */}
//                 <div className="w-[90%] mx-auto md-lg:block hidden">
//                     <button
//                         onClick={() => setFilterShow(prev => !prev)}
//                         aria-label="Toggle navigation menu"
//                         className="flex justify-center items-center w-[36px] h-[36px] border rounded-lg mt-2 py-2 px-2"
//                         style={{ backgroundColor: sellerSecondaryColor1, color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}
//                     >
//                         <FaList />
//                     </button>
//                 </div>

//                 <div className="h-full mx-auto">
//                     <div className="py-2 flex md-lg:w-[90%] mx-auto relative">
//                         {/* Sidebar */}
//                         <nav
//                             className={`rounded-md z-50 md-lg:absolute ${filterShow ? '-left-4' : '-left-[360px]'} w-[178px] p-1 ml-3 border transition-all duration-300`}
//                             style={{ backgroundColor: sellerSecondaryColor1, color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}
//                         >
//                             <ul className="py-1 px-1 text-[13px]">
//                                 {visibleNavItems.map(item => (
//                                     <NavItem
//                                         key={item.path}
//                                         path={item.path}
//                                         label={item.label}
//                                         icon={item.icon}
//                                         currentPath={pathname}
//                                         onClick={goToPage}
//                                         borderColor={sellerPrimaryColor1}
//                                     />
//                                 ))}

//                                 {/* Logout */}
//                                 <li className="flex justify-start items-center py-1">
//                                     <div
//                                         onClick={logout}
//                                         className="w-full flex cursor-pointer justify-start items-center gap-1 pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md hover:font-semibold hover:pl-3 transition-all duration-300"
//                                         style={{ borderColor: sellerPrimaryColor1 }}
//                                     >
//                                         <span className="text-[18px]"><IoMdLogOut /></span>
//                                         Logout
//                                     </div>
//                                 </li>
//                             </ul>
//                         </nav>

//                         {/* Main content */}
//                         <div className="w-[calc(100%-270px)] md-lg:w-full">
//                             <div className="mx-4 md-lg:mx-0">
//                                 <Outlet />
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default CustomerDashboard;




//my original code
// import React, { useEffect, useState }  from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';

// import { FaList, FaUser, FaHeart, FaRegUser, FaEye, FaRegHeart } from 'react-icons/fa';
// import { IoIosHome, IoMdLogOut } from "react-icons/io";
// import { FaBorderAll, FaCartShopping } from "react-icons/fa6";
// import { MdOutlineRestaurantMenu, MdPayment, MdOutlineTableBar } from "react-icons/md";
// import { RiRestaurant2Line } from "react-icons/ri";
// import { IoChatbubbleEllipsesOutline, IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { AiOutlineDashboard, AiOutlineShoppingCart } from "react-icons/ai";
// import { GoGift } from "react-icons/go";
// import { TbListDetails } from "react-icons/tb";
// import { FaThumbsUp } from "react-icons/fa";
// import { FaRegThumbsUp } from "react-icons/fa";
// import { RiLockPasswordLine } from "react-icons/ri";
// import { FaAnglesRight } from "react-icons/fa6";

// import api from '../api/api';

// import { get_product_deposit_details } from '../store/reducers/homeReducer';
// import { get_event_details, messageClear } from '../store/reducers/eventDetailsReducer';
// import { user_reset } from '../store/reducers/authReducer'
// import { reset_count } from '../store/reducers/cartReducer'

// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import GetSellerConfig from '../components/GetSellerConfig';

// import toast from 'react-hot-toast';
// import config from '../config';

// const CustomerDashboard = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL

//     const { userInfo } = useSelector(state => state.auth)
//     const { depositProduct } = useSelector(state => state.home)
//     const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
//     //const { seller } = useSelector(state => state.seller)
//     //console.log('seller in customerDashboard', eventDetails)//customMenuProducts

//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia,
//         sellerBoolShowSiteSamplesMenus, sellerBoolShowSitePackages, sellerBoolShowCustomerTestimonials, sellerBoolShowSitePayments
//     } = GetSellerConfig();

//     const [filterShow, setFilterShow] =  useState(false)
    
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     // const {pathName} = useLocation()
//     const currentUrl = window.location.href;
//     //console.log(currentUrl)
//     const pathName = window.location.pathname; //
//     //console.log(pathName)

//     useEffect(() => {
//         dispatch(get_product_deposit_details(sellerFrontendURL)) //slug is productId
//         dispatch(get_event_details(userInfo.id))
//     },[])
        
//     ///eventDetails?.customMenuProducts
//     const [customMenuProductsLength, setCustomMenuProductsLength] = useState(0)
//     useEffect(() => {
//         if(eventDetails?.customMenuProducts){
//             //console.log("Parsing customMenuProducts...");
//             setCustomMenuProductsLength(JSON.parse(eventDetails?.customMenuProducts).length);
//             //setSelectedItems(JSON.parse(eventDetails?.customMenuProducts));
//             //console.log("SelectedItems:", selectedItems);
//         } else {
//             //console.log("No customMenuProducts found.");
//         }
//     }, [eventDetails?.customMenuProducts]);
//     const logout = async () => {
//         try {
//             toast.success('Logout Success')
//             const {data} = await api.get('/customer/logout')
//             localStorage.removeItem('customerToken')
//             dispatch(user_reset())
//             dispatch(reset_count())
//             navigate('/login')    
//         } catch (error) {
//             console.log(error.response.data)
//         }
//     }
//     const goToPage = (path) => {
//         navigate(path)
//         setFilterShow(false)
//         //console.log('pathName ', pathName)
//     }
//     // const goToDashboard = (path) => {
//     //     navigate('/customerDashboard')
//     //     setFilterShow(false)
//     // }
//     // const goToMyOrders = () => {
//     //     navigate('/customerDashboard/myOrders')
//     //     setFilterShow(false)
//     // }
//     // const goToMyProfile = () => {
//     //     navigate('/customerDashboard/myProfile')
//     //     setFilterShow(false)
//     // }

//     // const goToGiveDeposit = () => {
//     //     navigate('/customerDashboard/giveDeposit')
//     //     setFilterShow(false)
//     // }
//     // const goToEventDetails = () => {
//     //     navigate('/customerDashboard/eventDetailsCustomerDashboard')
//     //     setFilterShow(false)
//     // }

//     // const goToFloorPlanner = () => {
//     //     navigate('/customerDashboard/FloorPlanner')
//     //     setFilterShow(false)
//     // }

//     // const goToMyWishlist = () => {
//     //     navigate('/customerDashboard/myWishlist')
//     //     setFilterShow(false)
//     // }

//     // const goToSampleMenus = () => {
//     //     navigate('/customerDashboard/sampleMenus')
//     //     setFilterShow(false)
//     // }
//     // const goToSellerPackages = () => {
//     //     navigate('/customerDashboard/sellerPackages')
//     //     setFilterShow(false)
//     // }

//     // const goToChat = () => {
//     //     navigate(`/customerDashboard/chat`)
//     //     ///customerDashboard/chat/${sellerId}`
//     //     setFilterShow(false)
//     // }
//     // const goToChangePassword = () => {
//     //     navigate('/customerDashboard/changePassword')
//     //     setFilterShow(false)
//     // }
    
//     return (
//         <div>
//            <Header/>
//            <div className='bg-slate-200 pt-4'>
//                 <div className='w-[90%] mx-auto md-lg:block hidden'>
//                     <div>
//                         { /* justify-center items-center w-[36px] h-[36px] rounded-lg cursor-pointer */ }
//                         <button onClick={() => setFilterShow(!filterShow)} 
//                             className='justify-center items-center w-[36px] h-[36px] text-center border rounded-lg mt-2 py-2 px-2 '
//                             style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                             <FaList/>
//                         </button>
//                     </div>
//                 </div>
//                 <div className='h-full mx-auto'>
//                     <div className='py-2 flex md-lg:w-[90%] mx-auto relative'>
//                         <div className={`rounded-md z-50 md-lg:absolute 
//                             ${filterShow ? '-left-4' : '-left-[360px]'} w-[178px] p-1 ml-3 border`}
//                             style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                             {
//                                 // <div onClick={() => goToPage(n.path)} className={`${pathname === n.path ? 
//                                 //     'bg-blue-600 shadow-indigo-500/50 text-white duration-500' : 'text-[#030811] font-bold duration-200 ' } 
//                                 //     cursor-pointer px-[8px] py-[9px] rounded-sm flex justify-start items-center gap-[12px] 
//                                 //     hover:pl-4 transition-all w-full mb-1 `} >
//                                 //     <span>{n.icon}</span>
//                                 //     <span>{n.title}</span>
//                                 // </div>
//                                 //'/customerDashboard'
//                                 //onClick={goToDashboard}
//                                 //onClick={() => goToPage('/customerDashboard')} 

//                                 // <div onClick={() => goToPage(n.path)} 
//                                 //     className={`${pathName.pathname !== n.path ? 
//                                 //     'bg-blue-600 shadow-indigo-500/50 text-white duration-500' : 
//                                 //     'text-[#030811] font-bold duration-200 ' } 
//                                 //     cursor-pointer px-[8px] py-[6px] rounded-sm flex justify-start items-center gap-[8px] 
//                                 //     hover:pl-4 transition-all w-full mb-1 `} >
//                                 //     <span>{n.icon}</span>
//                                 //     <span className='text-md' >{n.title}</span>
//                                 // </div>
//                                 //                             {pathName
//                                 // === '/customerDashboard' ? <span className='ml-1'>(Current)</span> : ''
//                                 //                                     }
//                             }
//                             <ul className='py-1 px-1 text-[13px]'>
//                                 <li className=' flex justify-start items-center' >
//                                     <div onClick={() => goToPage('/customerDashboard')}
//                                         className={`w-full flex cursor-pointer justify-start items-center 
//                                         pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-bold hover:pl-3 hover:ease-in-out transition:transform 0.3s 
//                                         duration-300 `}
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         { /*pathName ==='/customerDashboard' ? 'text-xl mr-1 text-[#Edbb0E]' : 'text-xl mr-1'*/ }
//                                         <div className={` ${pathName ==='/customerDashboard' ? 'font-bold' : 'font-normal'}  
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-xl mr-1'><AiOutlineDashboard /></span>
//                                             My Dashboard 
//                                         </div>
//                                     </div>      
//                                 </li>
//                                 <li className='flex justify-start items-center py-1'>
//                                     <div onClick={() => goToPage('/customerDashboard/myOrders')} 
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-bold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/myOrders' ? 'font-bold' : 'font-normal'}  
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-xl mr-1'><AiOutlineShoppingCart /></span>
//                                             My Orders
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li className='flex justify-start items-center py-1'>
//                                     <div onClick={() => goToPage('/customerDashboard/myProfile')}  
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/myProfile' ? 'font-bold' : 'font-normal'}  
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-[16px] mr-1'><FaRegUser /></span>
//                                             My Profile
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li className={` ${depositProduct ? '' : 'hidden'} 
//                                     flex justify-start items-center py-1`}>
//                                     <div onClick={() => goToPage('/customerDashboard/giveDeposit')}  
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/giveDeposit' ? 'font-bold' : 'font-normal'} 
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-xl mr-1'><MdPayment /></span>
//                                             Give Deposit
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li className='flex justify-start items-center py-1'>
//                                     <div onClick={() => goToPage('/customerDashboard/eventDetailsCustomerDashboard')} 
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/eventDetailsCustomerDashboard' ? 'font-bold' : 'font-normal'} 
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-xl mr-1'><TbListDetails /></span>
//                                             Event Details
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li className='flex justify-start items-center py-1'>
//                                     <div  onClick={() => goToPage('/customerDashboard/FloorPlanner')} 
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/FloorPlanner' ? 'font-bold' : 'font-normal'} 
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-xl mr-1'><MdOutlineTableBar /></span>
//                                             Floor Planner
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li className={` ${sellerBoolShowSiteSamplesMenus ? '' : 'hidden'} 
//                                     flex justify-start items-center py-1`}>
//                                     <div onClick={() => goToPage('/customerDashboard/sampleMenus')} 
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/sampleMenus' ? 'font-bold' : 'font-normal'} 
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-xl mr-1'><MdOutlineRestaurantMenu /></span>
//                                             Sample Menus
//                                         </div>
//                                     </div>
//                                 </li>
//                                 {
//                                     // JSON.parse(eventDetails?.customMenuProducts).length > 0 ?
//                                     //  ${JSON.parse(eventDetails?.customMenuProducts).length > 0 ? '' : 'hidden'}
//                                     //console.log('customMenuProducts', eventDetails?.customMenuProducts)

//                                 }
//                                 <li className={` ${customMenuProductsLength > 0 ? '' : 'hidden'}
//                                     flex justify-start items-center py-1`}>
//                                     <div onClick={() => goToPage('/customerDashboard/myCustomMenu')} 
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/myCustomMenu' ? 'font-bold' : 'font-normal'} 
//                                             hover:font-bold flex justify-start items-center`} >   
//                                             <span className='text-xl mr-1'><MdOutlineRestaurantMenu /></span>
//                                             My Custom Menu
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li className={` ${sellerBoolShowSitePackages ? '' : 'hidden'} 
//                                     flex justify-start items-center py-1`}>
//                                     <div onClick={() => goToPage('/customerDashboard/sellerPackages')} 
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/sellerPackages' ? 'font-bold' : 'font-normal'} 
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-xl mr-1'><GoGift /></span>
//                                             Packages
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li className={` ${sellerBoolShowSiteWishList ? '' : 'hidden'} 
//                                     flex justify-start items-center py-1`}>
//                                     <div onClick={() => goToPage('/customerDashboard/myWishlist')} 
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/myWishlist' ? 'font-bold' : 'font-normal'} 
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-[18px] mr-1'><FaRegHeart/></span>
//                                             My Wishlist
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li className={` ${sellerBoolShowSiteChat ? '' : 'hidden' } 
//                                     flex justify-start items-center py-1`}>
//                                     <div onClick={() => goToPage('/customerDashboard/chat')} 
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/chat' ? 'font-bold' : 'font-normal'} 
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-[18px] mr-1'><IoChatbubbleEllipsesOutline /></span>
//                                             Chat
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li  className={` ${sellerBoolShowCustomerTestimonials ? '' : 'hidden' } 
//                                     flex justify-start items-center py-1`}>
//                                     <div onClick={() => goToPage('/customerDashboard/customerTestimonialsDashboard')} 
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300'
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <div className={` ${pathName ==='/customerDashboard/customerTestimonialsDashboard' ? 'font-bold' : 'font-normal'} 
//                                             hover:font-bold flex justify-start items-center`} >
//                                             <span className='text-[18px] mr-1'><FaRegThumbsUp /></span>
//                                             Testimonials
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li className='flex justify-start items-center py-1'>
//                                     <div onClick={logout} 
//                                         className='w-full flex cursor-pointer justify-start items-center pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md 
//                                         hover:font-semibold hover:pl-3 hover:ease-in-out transition:transform 0.3s duration-300' 
//                                         style={{borderColor:sellerPrimaryColor1}}>
//                                         <span className='text-[18px]'><IoMdLogOut/></span>
//                                         Logout
//                                         <span className='ml-1 hidden'>--</span>
//                                         {
//                                             //hover:opacity-100  hover:inline-block  opacity-100 group-hover:opacity-100  opacity-100 opacity-0
//                                         }
//                                     </div>
//                                 </li> 
//                             </ul>
//                         </div>
//                         <div className='w-[calc(100%-270px)] md-lg:w-full'>
//                             <div className='mx-4 md-lg:mx-0'>
//                                 <Outlet/>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//            </div>
//            <Footer/>
//         </div>
//     );
// };

// export default CustomerDashboard;




